import type { ResultStatus, RunStatus } from '@1qa/shared';
import { Ban, Check, CircleDashed, Clock3, SkipForward, TriangleAlert, X } from '@/components/icons';
import { Badge, type Tone } from './Badge';

type AnyStatus = RunStatus | ResultStatus;

// Figma status badges: RUNNING shows a dot, the others a 12px icon.
const meta: Record<AnyStatus, { label: string; tone: Tone; Icon: typeof Check | null }> = {
  QUEUED: { label: 'Queued', tone: 'pending', Icon: Clock3 },
  RUNNING: { label: 'Running', tone: 'info', Icon: null },
  PASSED: { label: 'Passed', tone: 'success', Icon: Check },
  FAILED: { label: 'Failed', tone: 'danger', Icon: X },
  ERROR: { label: 'Error', tone: 'warning', Icon: TriangleAlert },
  CANCELLED: { label: 'Cancelled', tone: 'muted', Icon: Ban },
  SKIPPED: { label: 'Skipped', tone: 'muted', Icon: SkipForward },
};

export function StatusPill({ status }: { status: AnyStatus }) {
  const m = meta[status] ?? { label: status, tone: 'neutral' as Tone, Icon: CircleDashed };
  return (
    <Badge tone={m.tone} icon={m.Icon ? <m.Icon className="size-3" aria-hidden /> : <span className="size-1.5 rounded-full bg-current" aria-hidden />}>
      {m.label}
    </Badge>
  );
}

export function statusLabel(status: AnyStatus): string {
  return meta[status]?.label ?? status;
}
